import React from 'react';
import PropTypes from 'prop-types';
import { I18n } from '@fiverr-private/fiverr_context';
import { formatDaysKey } from '../../../utils/packagesUtils';

import './style.scss';

class FakeCheckbox extends React.Component {

    constructor(props) {
        super(props);

        this.onChange = this.onChange.bind(this);
    }

    onChange(e) {
        const { checked } = e.target,
            { onChange } = this.props;

        onChange(checked);
    }

    render() {
        const {
            label,
            tooltip,
            checked,
            duration: days
        } = this.props;

        return (
            <label className="fake-checkbox">
                <input type="checkbox" checked={checked} onChange={this.onChange}/>
                <span className="checkbox"/>
                <span>
                    {label}
                    {tooltip &&
                    <span className="hint--top" data-hint={tooltip}>
                        <span className="fa fa-question-circle"/>
                    </span>
                    }
                    {days > 0 && <p>(+{days} <I18n k={formatDaysKey(days)}/>)</p>}
                </span>
            </label>
        );
    }
}

FakeCheckbox.propTypes = {
    label: PropTypes.string,
    duration: PropTypes.number,
    tooltip: PropTypes.string,
    onChange: PropTypes.func
}.isRequired;

FakeCheckbox.defaultProps = {
    onChange: () => true
};

export default FakeCheckbox;
